import Component from '@glimmer/component';
import { action } from '@ember/object';
import SpaceButton from 'madow-tech/components/space-button';
import Icon from 'madow-tech/components/icon';

interface RocketButtonSignature {
  Args?: {
    text?: string;
    sectionId?: string;
  };
  Element: HTMLDivElement;
}

export default class RocketButton extends Component<RocketButtonSignature> {
  @action
  scrollToContact() {
    const contactSection = document.getElementById(this.args.sectionId || 'contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  <template>
    <SpaceButton
      @variant="v2"
      @onClick={{this.scrollToContact}}
      class="navbar-cta-button !overflow-hidden"
      ...attributes
    >
      <span class="rocket-wrapper">
        <Icon @name="svg-rocket" @svgClass="min-h-4 min-w-4 rocket-icon rotate" />
        <span class="rocket-trail"></span>
        <span class="rocket-smoke"></span>
      </span>
      {{@text}}
    </SpaceButton>
  </template>
}
